import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import { ArrowRight } from '@/icons/index';

import styles from './Pagination.module.scss';

const Pagination = ({ perPage = 12, total = 0 }) => {
  const router = useRouter();
  const [currentPage, setCurrentPage] = useState(+router.query.page || 1);
  const displayedItemsCount = 3;

  const pagesCount = Math.ceil(total / perPage);
  const pages = Array.from({ length: pagesCount }, (_, i) => i + 1);

  useEffect(() => {
    router.push(
      {
        query: {
          ...router.query,
          page: currentPage,
        },
      },
      undefined,
      {
        scroll: true,
        scrollOptions: {
          behavior: 'smooth',
        },
      },
    );
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(+router.query.page || 1);
  }, [pagesCount, router.query.page]);

  const getShowedItems = (array) => {
    let showed = [];

    if (array.length <= displayedItemsCount) {
      showed = array;
    } else {
      if (currentPage <= 4) {
        showed = array.slice(0, 5);
      } else if (currentPage > pagesCount - 4) {
        showed = array.slice(pagesCount - 5);
      } else {
        showed = [currentPage - 1, currentPage, currentPage + 1];
      }

      if (currentPage > 4 && showed[0] > 2) {
        showed.unshift(1, '...');
      } else if (showed[0] === 2) {
        showed.unshift(1);
      }

      if (
        currentPage < pagesCount - 3 &&
        showed[showed.length - 1] < pagesCount - 1
      ) {
        showed.push('...', pagesCount);
      } else if (showed[showed.length - 1] === pagesCount - 1) {
        showed.push(pagesCount);
      }
    }
    return showed;
  };

  const renderItem = (item, key) => {
    let page;
    let pageLabel;
    if (item === '...') {
      pageLabel = item;
      page = key === 1 ? currentPage - 2 : currentPage + 2;
    } else {
      page = item;
      pageLabel = page;
    }

    return (
      <div
        className={`${styles.item} ${
          currentPage === page ? styles.active : ''
        }`}
        onClick={() => setCurrentPage(page)}
        key={key}
      >
        {pageLabel}
      </div>
    );
  };

  return (
    !!pages.length && (
      <div
        className={styles.pagination}
        itemScope
        itemType='https://schema.org/Property'
      >
        <div
          className={`${styles.item} ${styles.nav} ${
            currentPage === 1 ? styles.disabled : ''
          }`}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          <ArrowRight className={`${styles.icon} ${styles.prev}`} />
        </div>
        {getShowedItems(pages).map(renderItem)}
        <div
          className={`${styles.item} ${styles.nav} ${
            currentPage === pagesCount ? styles.disabled : ''
          }`}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          <ArrowRight className={`${styles.icon} ${styles.next}`} />
        </div>
      </div>
    )
  );
};

export default Pagination;
